export default __webpack_public_path__ + "static/media/element_30.fca8ca62.avif";